import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { PageHead } from "@/components/PageHead";
import { Reveal } from "@/components/Reveal";
import { CtaSection } from "@/components/CtaSection";
import { FAQS } from "@/lib/data";

export default function Faq() {
  return (
    <>
      <PageHead
        eyebrow="FAQ"
        title="Straight answers, before you even have to ask."
        sub="The questions every business owner asks us, answered the way we'd answer them over a coffee."
        testid="faq-page-title"
      />
      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pb-16 sm:pb-24">
        <Reveal>
          <Accordion type="single" collapsible data-testid="faq-accordion" className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem key={f.q} value={`item-${i}`} data-testid={`faq-item-${i}`}>
                <AccordionTrigger data-testid={`faq-question-${i}`} className="text-left font-semibold">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-10 text-sm text-muted-foreground">
            Something else on your mind?{" "}
            <Link to="/contact" data-testid="faq-contact-link" className="font-semibold text-primary hover:underline underline-offset-4">
              Ask us directly
            </Link>{" "}
            and a real person replies within one business day.
          </p>
        </Reveal>
      </section>
      <CtaSection />
    </>
  );
}
